import { StackView } from "@telus-uds/components-base";

function ScreenWrapper({ children }) {
  return (
    <StackView tokens={{ flexGrow: 1, flexShrink: 1 }}>{children}</StackView>
  );
}

export default ScreenWrapper;
